import { html } from '../../../html.js';
import type { VNode } from '../../../html.js';
import type { DashboardActions, DashboardState } from '../../store.js';
import { MembersSection, heldOperatorSecret } from '../../ui/members.js';

/**
 * Tab five: who else can open this site's dashboard.
 *
 * The section is mounted as a COMPONENT keyed by tenant, unlike every other
 * tab, which is a function call over the store's state: the access list keeps
 * its own state and runs its own fetches (ui/members.ts), and the key is what
 * stops one site's list surviving a jump to another.
 *
 * The secret is a getter because the store forgets its mirror the moment the
 * unlock succeeds; a 401 is routed through `reload`, whose own 401 lands on the
 * login screen with the right sentence for whichever principal just expired.
 */
export function AccessTab(props: {
  tenantId: string;
  state: DashboardState;
  actions: DashboardActions;
  now: number;
}): VNode {
  const { tenantId, state, actions, now } = props;
  return html`
    <div class="tabpanel">
      <${MembersSection}
        key=${`access-${tenantId}`}
        tenantId=${tenantId}
        secret=${() => state.secret || heldOperatorSecret()}
        now=${now}
        onUnauthorized=${() => actions.reload()}
      />
    </div>
  `;
}
